import React, { useState, useEffect } from "react";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import firebase from "../../firebase";

const Feedback = () => {
  const [user, setUser] = useState([]);
  useEffect(() => {
    firebase
      .firestore()
      .collection("feedback")
      .orderBy("state", "asc")
      .onSnapshot((snapshot) =>
        setUser(snapshot.docs.map((doc) => doc.data()))
      );
  }, []);
  const count = Object.keys(user).length;
  return (
    <div className="admin">
      <div className="head2" style={{ marginBottom: "10px" }}>
        <ReactHTMLTableToExcel
          className="btn"
          table="feedback"
          filename="feedback"
          sheet="Sheet"
          buttonText="Export excel"
        />
        <p style={{ textAlign: "right" }}>
          Total Feedback: <b>{count}</b>
        </p>
      </div>
      <table id="feedback" style={{ width: "100%", textAlign: "center" }}>
        <thead>
          <tr>
            <th>Full Name</th>
            <th>Designation</th>
            <th>Mobile Number</th>
            <th>College</th>
            <th>State</th>
          </tr>
        </thead>
        <tbody>
          {user.map(
            ({ name, sec, mobile, coll, state, dege, rate, help, sugg }) => (
              <tr key={sec}>
                <td className="feedback-table">{name}</td>
                <td className="feedback-table">{dege}</td>
                <td className="feedback-table">{mobile}</td>
                <td
                  className="feedback-table"
                  style={{ wordWrap: "break-word" }}
                >
                  {coll}
                </td>
                <td className="feedback-table">{state}</td>
                <td className="feedback-table">{rate}⭐</td>
                <td className="feedback-table">{help}</td>
                <td className="feedback-table">
                  {sugg ? sugg : <b>No Suggestion</b>}
                </td>
              </tr>
            )
          )}
        </tbody>
      </table>
    </div>
  );
};

export default Feedback;
